﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingBank } from "@tabler/icons-react";
import { BancosDef } from "./BancosDef";

export const BancosIcon = IconBuildingBank;
export const BancosHelpText = "* Contiene los bancos con los que opera la institución";

export class Bancos extends Entity<BancosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new BancosDef(), parentKeys);
        super.Form = "AutoForm";
        this.Title = "Bancos";
        this.Icon = BancosIcon;
        this.HelpText = BancosHelpText;
    }
}